import { FaDiscord, FaInstagram, FaTelegram, FaTwitch, FaXTwitter, FaYoutube } from "react-icons/fa6";

export const ADMIN_EMAIL = "business@thehuskobiscuit.com";

export const SOCIALS = [
  {
    id: "instagram",
    name: "Instagram",
    handle: "@thehuskobiscuitfursuiter",
    href: "https://www.instagram.com/thehuskobiscuitfursuiter",
    blurb: "Photo dumps & fluff",
    color: "#FF2A85",
    icon: FaInstagram,
  },
  {
    id: "twitter",
    name: "Twitter / X",
    handle: "@TheHuskoBiscuit",
    href: "https://x.com/TheHuskoBiscuit",
    blurb: "Posting, awoo edition",
    color: "#00F0FF",
    icon: FaXTwitter,
  },
  {
    id: "youtube",
    name: "YouTube",
    handle: "@thehuskobiscuit",
    href: "https://www.youtube.com/@thehuskobiscuit",
    blurb: "Tarkov montages & clips",
    color: "#FFDF00",
    icon: FaYoutube,
  },
  {
    id: "twitch",
    name: "Twitch",
    handle: "thehuskobiscuit",
    href: "https://www.twitch.tv/thehuskobiscuit",
    blurb: "Live zoomies most weeks",
    color: "#8A2BE2",
    icon: FaTwitch,
  },
  {
    id: "telegram",
    name: "Telegram",
    handle: "@TheHuskoBiscuit",
    href: "https://t.me/TheHuskoBiscuit",
    blurb: "DMs open for friendly pings",
    color: "#00F0FF",
    icon: FaTelegram,
  },
  {
    id: "discord",
    name: "Husko's Pawsitive Corner <3",
    handle: "discord.gg/3jF4bbTAEJ",
    href: "https://discord.gg/3jF4bbTAEJ",
    blurb: "The official Discord server — join the pack",
    color: "#FF2A85",
    icon: FaDiscord,
  },
];

export const HERO_IMAGE = "/felix-hero.webp";
export const ABOUT_IMAGE = "/felix-portrait.webp";
export const OUTDOOR_IMAGE = "/felix-garden.jpg";
export const PARADE_IMAGE =
  "https://images.unsplash.com/photo-1688304261314-0f34e4fb5c3f?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200";
